export default __webpack_public_path__ + "static/media/start-giftting2.de7201d8.svg";